import script from "./approved-transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./approved-transactions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__